import { render, staticRenderFns } from "./ClubMembership.vue?vue&type=template&id=1f38a90c"
import script from "./ClubMembership.vue?vue&type=script&lang=js"
export * from "./ClubMembership.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports